import { useEffect } from 'react';

const useBodyClass = (className: string) => {
    useEffect(() => {
        document.body.className = className;
        return () => {
            document.body.className = '';
        };
    });
};

export default useBodyClass;
